import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditBankAccountComponent } from './edit-bank-account.component';
import { SharedModule } from '@shared/shared.module';
import { MatDialogCustomModule } from '../mat-dialog-custom/mat-dialog-custom.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectCountryModule } from '@shared/select-country/select-country.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TreoMessageModule } from '@treo/components/message';
import { ErrorMinValuePipeModule } from '@pipes/error-min-value/error-min-value.module';
import { ErrorMaxValuePipeModule } from '@pipes/error-max-value/error-max-value.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CurrencyCountryPipeModule } from '@pipes/currency-country/currency-country.module';
import { MaskAccountNumberModule } from '@pipes/mask-account-number/mask-account-number.module';

@NgModule({
  declarations: [EditBankAccountComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatDialogCustomModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    FormsModule,
    SelectCountryModule,
    MatDialogModule,
    TreoMessageModule,
    ErrorMinValuePipeModule,
    ErrorMaxValuePipeModule,
    MatTooltipModule,
    CurrencyCountryPipeModule,
    MaskAccountNumberModule,
  ],
  exports: [EditBankAccountComponent],
})
export class EditBankAccountModule {}
